import React from 'react';
import { Helmet } from 'react-helmet';
import InfoBox from '../../components/info-box/info-box';

import './about-wrapper.css';

const AboutWrapper = ({data}) => {

  return (
    <div className="about-wrapper">
        <Helmet>
            <title>About US</title>
            <meta property="og:title" content="About Pendo Presbyterian Church" />
            <meta name="description" content={`A little about Pendo Presbyterian Church. - ${data?.aboutUs?.text}`} />
        </Helmet>
        <div className="row about-us-wrapper">
          <InfoBox title={data.aboutUs.title} text={data.aboutUs.text}/>
        </div>
        <div className='footer full-width margin-top-5'>
          <div className="container center">
            <p>&copy; {data.footer.text}</p>
          </div>
        </div>
    </div>
  );

}

export default AboutWrapper;
